import Styles from './PublicLabView.module.scss';
import { useEffect, useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { useAPI, AuthContext } from 'components/lib';
import { AccessTime, CalendarToday, MilitaryTech, Science } from '@mui/icons-material';
import ReactPlayer from 'react-player';
import LabList from './LabList';
import LPathList from './LPathList';
import InternshipList from './InternshipList';

export function PublicLabView({ ...props }) {
    const { id } = useParams();
    const { product } = useParams();
    const authContext = useContext(AuthContext);

    const navigate = useNavigate();
    const url = window.location.search;
    const signUpParams = new URLSearchParams(url);
    const source = signUpParams.get('source');
    const Event = require('components/lib').Event;
    const [showFullDesc, setShowFullDesc] = useState(false);
    const toggleDescription = () => setShowFullDesc((prev) => !prev);

    // eslint-disable-next-line no-unused-vars
    const { data, loading } = useAPI(`/api/public/${product}/${id}`);
    window.dataLayer = window.dataLayer || [];

    useEffect(() => {
        document.title = product.toUpperCase();
        if (data) {
            document.title = data?.name;
            if (source) {
                Event(`${source}_view_${product}_${data?.name}`);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    const handleProductClick = () => {
        window.dataLayer.push({
            event: 'buyNowClicked',
            data: {
                productType: product,
                productName: data?.name || null
            }
        });
        const path = product === 'lpath' ? `/lpaths/info/${id}`
            : product === 'internship' ? `/internships/info/${id}` : `/labs/info/${id}`;
        if (authContext?.user?.token) {
            navigate(path, {
                state: { redirectTo: path }
            });
        } else {
            navigate(`/signup?source=website&origin=${product}&name=${data?.name}`, {
                state: { redirectTo: path }
            });
        }
    };

    const renderIcon = (iconName) => {
        switch (iconName) {
            case 'clock':
                return (
                    <AccessTime sx={{ height: '18px', width: '18px', color: '#FFFFFF' }} />
                );
            case 'calendar':
                return (
                    <CalendarToday sx={{ height: '18px', width: '18px', color: '#FFFFFF' }} />
                );
            case 'certificate':
                return <MilitaryTech fontSize='medium' />;
            case 'lab':
                return <Science fontSize='medium' />;
            default:
                return null;
        }
    };

    return (
        <>
            {data?.nodes?.length !== 0 ? (
                <div id='ancestor' className={Styles.ancestor}>
                    <div id='headerContainer' className={Styles.headerContainer}>
                        <div id='headerContent' className={Styles.headerContent}>
                            <div id='labImageContainer' className={Styles.labImageContainer}>
                                <img
                                    src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data?.icon}`}
                                    alt='labLogo'
                                />
                            </div>
                            <h1 id='labNameContainer' className={Styles.labNameContainer}>
                                {data?.name} {
                                    product === "lpath" ? "Certification"
                                        : product === "project" ? "Project"
                                            : product === "internship" ? "Internship"
                                                : "Course"
                                }
                            </h1>
                        </div>
                        <div id='buttonContainer' className={Styles.buttonContainer}>
                            <AivagamButton
                                onClick={handleProductClick}
                                buttonText={"Buy Now"}
                                classStyles={{
                                    padding: "12px 24px",
                                    fontWeight: 700,
                                    fontSize: "16px",
                                    width: "10em",
                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
                                }}
                                type="confirm"
                            />
                        </div>
                    </div>

                    <div id='contentContainer' className={Styles.contentContainer}>
                        <div id='childOne' className={Styles.childOne}>
                            {product !== "internship" &&
                                <p
                                    id='nodesIncludedTitle'
                                    className={Styles.labNameContainer}
                                    style={{ color: "black", padding: '0.5em 1em' }}
                                >
                                    {(product === "lab" || product === "project") ? "Modules Included:" : "Courses Included"}
                                </p>}

                            {product === "lab" ? <LabList data={data} />
                                : product === "internship" ? <InternshipList data={data} />
                                    : <LPathList data={data} />}
                            {product === "project" && <LabList data={data} />}

                        </div>

                        <div id='childTwo' className={Styles.childTwo}>
                            {product !== "internship" && <ReactPlayer
                                id='reactPlayer'
                                className={Styles.videoPlayer}
                                url={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/media/git/video/commit.mp4`}
                                controls={true}
                                width="400px"
                                height="220px"
                            />}
                            <div id='labContainer' className={Styles.labContainer}>
                                <h1 className={Styles.descriptionTitle}>Description</h1>
                                <span id='infoContainer' className={Styles.infoContainer}>
                                    <p id='labDescr' className={Styles.labDescr}>
                                        {showFullDesc
                                            ? data?.descr
                                            : product === "internship" ? data?.descr?.slice(0, 280) + "..." : data?.descr?.slice(0, 180) + "..."}
                                        <button
                                            id='readMoreBtn'
                                            className={Styles.readMoreBtn}
                                            onClick={toggleDescription}
                                            type="button"
                                        >
                                            {showFullDesc ? "Read Less" : "Read More"}
                                        </button>
                                    </p>

                                    <div id='metaContainer' className={Styles.metaContainer}>
                                        {(product === "lab" || product === "project") && (
                                            <>
                                                <div id='metaItem_1' className={Styles.metaItem}>
                                                    {renderIcon('clock')}
                                                    <span>
                                                        {Math.ceil(data?.nodes.length / 2) + 1} Learning Hours
                                                    </span>
                                                </div>
                                                <div id='metaItem_2' className={Styles.metaItem}>
                                                    {renderIcon('calendar')}
                                                    <span>3 Month Access</span>
                                                </div>
                                                <div id='certificateLab' className={Styles.certificate}>
                                                    <span>NASSCOM Micro-Certificate</span>
                                                </div>
                                            </>
                                        )}
                                        {product === "lpath" && (
                                            <>
                                                <div id='metaItem_3' className={Styles.metaItem}>
                                                    {renderIcon('clock')}
                                                    <span>
                                                        {Math.ceil(((60 * 5) * data?.labs.length) / 60)}{" "}
                                                        Learning Hours
                                                    </span>
                                                </div>
                                                <div id='metaItem_4' className={Styles.metaItem}>
                                                    {renderIcon('calendar')}
                                                    <span>3 Month Access</span>
                                                </div>
                                                <div id='certificateLpath' className={Styles.certificate}>
                                                    <span>NASSCOM Certificate</span>
                                                </div>
                                            </>
                                        )}
                                        {product === "internship" && (
                                            <>
                                                <div id='metaItem_4' className={Styles.metaItem}>
                                                    {renderIcon('calendar')}
                                                    <span>3 Month Access</span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </span>
                            </div>

                            {!authContext?.user?.token && (
                                <div id='signUpContainer' className={Styles.signUpContainer}>
                                    Sign Up Now and Get Access to a Free Lab!
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                <p id='loadingText' className={Styles.loadingText}>
                    Getting this content ready for you!
                </p>
            )}
        </>
    );
}
